import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import StudentLoadIntentService from "../../../Services/StudentLoadIntent.service";
import StudentLoadIntentStatusLookupModal from "./StudentLoadIntentStatusLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => StudentLoadIntentService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const StudentLoadIntentStatusSearch = makeSearch(makeSearchArgs);
export const StudentLoadIntentMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<StudentLoadIntent, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: StudentLoadIntentStatusLookupModal }));
